(function () {
  var sections = document.querySelectorAll("[data-quick-add-feature]");
  if (!sections.length) return;
  var MAX_BIND_RETRIES = 20;
  var BIND_RETRY_DELAY = 120;

  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(String(value));
    }
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function normalizePlanId(value) {
    if (value == null) return "";
    var raw = String(value).trim();
    if (!raw) return "";
    var match = raw.match(/\d+/);
    return match ? match[0] : "";
  }

  function getActiveQuickViewItem() {
    return document.querySelector('[data-quick-view-item-holder].is-active [data-quick-view-item]');
  }

  function getFormFromItem(item) {
    if (!item) return null;
    return item.querySelector("form.product__form, form.shopify-product-form");
  }

  function getProductJsonFromItem(item) {
    if (!item) return null;
    if (item._qafProductJson) return item._qafProductJson;

    var jsonNode = item.querySelector("script[data-product-json]");
    if (!jsonNode) return null;

    try {
      item._qafProductJson = JSON.parse(jsonNode.textContent || "{}");
      return item._qafProductJson;
    } catch (error) {
      return null;
    }
  }

  function variantSupportsPlan(variant, planId) {
    if (!variant || !planId) return false;
    var normalizedPlanId = normalizePlanId(planId);
    if (!normalizedPlanId) return false;

    var globalPlansMap = window.variantSellingPlans || {};
    var globalVariantPlans = globalPlansMap[String(variant.id)];
    if (Array.isArray(globalVariantPlans)) {
      for (var gp = 0; gp < globalVariantPlans.length; gp += 1) {
        if (normalizePlanId(globalVariantPlans[gp]) === normalizedPlanId) {
          return true;
        }
      }
    }

    var allocations = variant.selling_plan_allocations || [];
    for (var i = 0; i < allocations.length; i += 1) {
      var allocation = allocations[i] || {};
      var allocationPlanId = allocation.selling_plan_id
        || (allocation.selling_plan && allocation.selling_plan.id);
      if (normalizePlanId(allocationPlanId) === normalizedPlanId) return true;
    }
    return false;
  }

  function getSelectedOptionValue(form, optionIndex) {
    if (!form) return "";
    var baseSelector = '[data-single-option-selector][data-index="option' + optionIndex + '"]';
    var checked = form.querySelector(baseSelector + ':checked');
    if (checked && checked.value != null) return String(checked.value);

    var first = form.querySelector(baseSelector);
    if (first && first.value != null) return String(first.value);
    return "";
  }

  function normalizeText(value) {
    return String(value || "").trim().toLowerCase();
  }

  function setOptionValueByIndex(form, optionIndex, targetValue) {
    if (!form || !optionIndex || !targetValue) return false;
    var normalizedTarget = normalizeText(targetValue);
    var selector = '[data-single-option-selector][data-index="option' + optionIndex + '"]';
    var candidates = form.querySelectorAll(selector);
    var matched = false;

    candidates.forEach(function (input) {
      var inputValue = normalizeText(input.value || "");
      if (inputValue !== normalizedTarget) return;

      if (input.type === "radio" || input.type === "checkbox") {
        input.checked = true;
      } else {
        input.value = input.value;
      }
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
      matched = true;
    });

    return matched;
  }

  function getSupplyAmountOptionIndex(root) {
    if (!root) return null;
    var wrapper = root.querySelector('.product__selectors [data-option-name="supply-amount"]');
    if (!wrapper) return null;
    var optionPosition = wrapper.getAttribute("data-option-position");
    if (!optionPosition) return null;
    var parsed = parseInt(optionPosition, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function setSupplyAmountFromText(root, text) {
    if (!root || !text) return false;
    var item = root.closest("[data-quick-view-item]") || getActiveQuickViewItem();
    var form = getFormFromItem(item);
    var supplyOptionIndex = getSupplyAmountOptionIndex(root);
    if (!form || !supplyOptionIndex) return false;

    var matchedExplicit = setOptionValueByIndex(form, supplyOptionIndex, text);
    if (matchedExplicit) return true;

    // Fallback for strings like "28 sachets every 28 days for 12 weeks".
    var sachetMatch = String(text).match(/(\d+)\s*sachets?/i);
    if (sachetMatch && sachetMatch[1]) {
      return setOptionValueByIndex(form, supplyOptionIndex, sachetMatch[1] + " Sachets");
    }
    return false;
  }

  function setSupplyAmountForPlanId(root, planId, fallbackText) {
    if (!root) return false;
    // No hardcoded selling-plan map. We derive from visible selection text.
    return setSupplyAmountFromText(root, fallbackText || "");
  }

  function scoreVariantMatch(variant, selectedOptions) {
    if (!variant) return -1;
    var score = 0;
    if (selectedOptions.option1 && String(variant.option1 || "") === selectedOptions.option1) score += 8;
    if (selectedOptions.option2 && String(variant.option2 || "") === selectedOptions.option2) score += 4;
    if (selectedOptions.option3 && String(variant.option3 || "") === selectedOptions.option3) score += 2;
    return score;
  }

  function setVariantOptionInput(form, optionIndex, optionValue) {
    if (!form || !optionValue) return;

    var selector = '[data-single-option-selector][data-index="option' + optionIndex + '"]';
    var candidates = form.querySelectorAll(selector);

    candidates.forEach(function (input) {
      if ((input.value || "") !== optionValue) return;
      if (input.type === "radio" || input.type === "checkbox") {
        input.checked = true;
      } else {
        input.value = optionValue;
      }
      input.dispatchEvent(new Event("change", { bubbles: true }));
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }

  function syncVariantIdInForm(form, variant) {
    if (!form || !variant || !variant.id) return;
    var idInput = form.querySelector('input[name="id"][data-product-select], input[name="id"]');
    if (!idInput) return;

    idInput.value = variant.id;
    idInput.dispatchEvent(new Event("change", { bubbles: true }));
    idInput.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function syncVariantForSellingPlan(item, planId, options) {
    if (!item || !planId) return;
    var syncOptions = !options || options.syncOptions !== false;

    var productData = getProductJsonFromItem(item);
    var form = getFormFromItem(item);
    if (!productData || !form || !Array.isArray(productData.variants)) return;

    var idInput = form.querySelector('input[name="id"][data-product-select], input[name="id"]');
    var currentVariantId = idInput ? String(idInput.value || "") : "";

    var currentVariant = null;
    var supportedVariants = [];

    productData.variants.forEach(function (variant) {
      if (!variant || !variant.id) return;
      if (String(variant.id) === currentVariantId) {
        currentVariant = variant;
      }
      if (variantSupportsPlan(variant, planId)) {
        supportedVariants.push(variant);
      }
    });

    if (currentVariant && variantSupportsPlan(currentVariant, planId)) {
      return;
    }
    if (!supportedVariants.length) return;

    var selectedOptions = {
      option1: getSelectedOptionValue(form, 1),
      option2: getSelectedOptionValue(form, 2),
      option3: getSelectedOptionValue(form, 3),
    };

    var bestVariant = supportedVariants[0];
    var bestScore = scoreVariantMatch(bestVariant, selectedOptions);
    for (var i = 1; i < supportedVariants.length; i += 1) {
      var candidate = supportedVariants[i];
      var score = scoreVariantMatch(candidate, selectedOptions);
      if (score > bestScore) {
        bestVariant = candidate;
        bestScore = score;
      }
    }

    if (syncOptions) {
      setVariantOptionInput(form, 1, bestVariant.option1);
      setVariantOptionInput(form, 2, bestVariant.option2);
      setVariantOptionInput(form, 3, bestVariant.option3);
    }
    syncVariantIdInForm(form, bestVariant);
  }

  function clearSellingPlanSelection(root) {
    if (!root) return;
    root.querySelectorAll('.product__subs__plans input[name="selling_plan"]').forEach(function (input) {
      input.checked = false;
    });
  }

  function showSubscriptionInfo(root, subscriptionType) {
    if (!root) return;
    root.querySelectorAll(".card-info").forEach(function (info) {
      info.classList.add("hidden");
    });
    if (!subscriptionType) return;

    var targetInfo = root.querySelector('.card-info[data-subscription-type="' + subscriptionType + '"]');
    if (targetInfo) targetInfo.classList.remove("hidden");
  }

  function setSellingPlanById(root, planId, item) {
    if (!root || !planId) return null;
    var normalizedPlanId = normalizePlanId(planId);
    if (!normalizedPlanId) return null;
    clearSellingPlanSelection(root);

    var target = root.querySelector('.product__subs__plans input[name="selling_plan"][value="' + escapeSelectorValue(normalizedPlanId) + '"]');
    if (!target) return null;

    target.checked = true;
    target.value = normalizedPlanId;
    syncVariantForSellingPlan(item || getActiveQuickViewItem(), target.value);
    return target;
  }

  function handleRegularPlanSelection(root, regularPlanRadio, item) {
    if (!root || !regularPlanRadio) return;

    var regularContainer = root.querySelector('.regular-subscriptions-main[data-subscription-type="regular-subscriptions"]');
    var regularCard = regularPlanRadio.closest(".program-card");
    if (regularContainer) {
      regularContainer.querySelectorAll(".program-card").forEach(function (card) {
        card.classList.remove("program-card--active");
      });
    }
    if (regularCard) {
      regularCard.classList.add("program-card--active");
    }

    regularPlanRadio.checked = true;
    var cardsContainer = root.querySelector(".program-cards");
    var mainRegularCard = cardsContainer
      ? cardsContainer.querySelector(":scope > .program-card--regular-subscriptions-general")
      : root.querySelector(".program-card--regular-subscriptions-general");

    if (cardsContainer) {
      cardsContainer.querySelectorAll(":scope > .program-card").forEach(function (card) {
        card.classList.remove("program-card--active");
      });
    }
    if (mainRegularCard) {
      mainRegularCard.classList.add("program-card--active");
      var mainRadio = mainRegularCard.querySelector('.program-card__radio[name="selling-plan-group"]');
      if (mainRadio) mainRadio.checked = true;
    }

    showSubscriptionInfo(root, "regular-subscriptions");

    var regularCardText = regularPlanRadio.closest(".program-card");
    var deliveryTextNode = regularCardText ? regularCardText.querySelector(".delivery-msg span") : null;
    var deliveryText = deliveryTextNode ? deliveryTextNode.textContent : "";
    setSupplyAmountForPlanId(root, regularPlanRadio.value, deliveryText);

    setSellingPlanById(root, regularPlanRadio.value, item);
  }

  function setSellingPlanForCard(root, card) {
    if (!root || !card) return;
    clearSellingPlanSelection(root);

    var planInCard = card.querySelector('.product__subs__plans input[name="selling_plan"]:checked') || card.querySelector('.product__subs__plans input[name="selling_plan"]');
    if (planInCard) {
      planInCard.checked = true;
      var item = root.closest("[data-quick-view-item]") || getActiveQuickViewItem();
      syncVariantForSellingPlan(item, planInCard.value);
      return;
    }

    if (card.classList.contains("program-card--regular-subscriptions-general")) {
      var selectedRegular = root.querySelector('.regular-subscriptions-main .selling_plan_program-card__radio:checked')
        || root.querySelector('.regular-subscriptions-main .selling_plan_program-card__radio');
      if (selectedRegular) {
        handleRegularPlanSelection(root, selectedRegular, root.closest("[data-quick-view-item]") || getActiveQuickViewItem());
      }
      return;
    }
  }

  function activateSubscriptionCard(root, card) {
    if (!root || !card) return;
    var mainRadio = card.querySelector('.program-card__radio[name="selling-plan-group"]');

    root.querySelectorAll(".program-card").forEach(function (c) {
      c.classList.remove("program-card--active");
    });
    card.classList.add("program-card--active");

    if (mainRadio) {
      mainRadio.checked = true;
    }

    var subscriptionType = mainRadio ? mainRadio.getAttribute("data-subscription-type") : null;
    showSubscriptionInfo(root, subscriptionType);

    if (subscriptionType === "supply-amount") {
      clearSellingPlanSelection(root);
      return;
    }

    setSellingPlanForCard(root, card);
  }

  function prepareSubscriptionStateForSubmit(root, activeQuickViewItem) {
    if (!root) return;
    var activeCard = root.querySelector(".program-card.program-card--active");
    if (!activeCard || activeCard.classList.contains("program-card--one-time")) {
      root.querySelectorAll('.product__subs__plans input[name="selling_plan"]').forEach(function (input) {
        input.checked = false;
      });
      return;
    }

    setSellingPlanForCard(root, activeCard);
    var selectedPlan = root.querySelector('.product__subs__plans input[name="selling_plan"]:checked');
    if (!selectedPlan) return;
    var selectedPlanId = normalizePlanId(selectedPlan.value);
    if (!selectedPlanId) {
      selectedPlan.checked = false;
      return;
    }
    selectedPlan.value = selectedPlanId;

    // Final guard: keep option state and variant aligned before request serialization.
    if (activeCard.classList.contains("program-card--regular-subscriptions-general")) {
      var selectedRegular = root.querySelector('.regular-subscriptions-main .selling_plan_program-card__radio:checked');
      var selectedDelivery = selectedRegular ? selectedRegular.closest(".program-card").querySelector(".delivery-msg span") : null;
      if (selectedDelivery) {
        setSupplyAmountFromText(root, selectedDelivery.textContent || "");
      }
    } else if (activeCard.getAttribute("data-selling-plan-group-id")) {
      var prepaidSelect = activeCard.querySelector("[data-selling-plan-select]");
      if (prepaidSelect && prepaidSelect.options && prepaidSelect.selectedIndex > -1) {
        setSupplyAmountFromText(root, prepaidSelect.options[prepaidSelect.selectedIndex].text || "");
      } else {
        var selectedPlanLabel = selectedPlan.closest("label");
        var selectedPlanTextNode = selectedPlanLabel ? selectedPlanLabel.querySelector("span") : null;
        if (selectedPlanTextNode) {
          // Single-plan prepaid cards have no dropdown; derive supply amount from plan label text.
          setSupplyAmountFromText(root, selectedPlanTextNode.textContent || "");
        }
      }
    }
    // Submit-time guard: align options + variant id to prevent stale preselected UI state.
    syncVariantForSellingPlan(activeQuickViewItem, selectedPlanId, { syncOptions: true });

    var form = getFormFromItem(activeQuickViewItem);
    var productData = getProductJsonFromItem(activeQuickViewItem);
    if (!form || !productData || !Array.isArray(productData.variants)) return;
    var idInput = form.querySelector('input[name="id"][data-product-select], input[name="id"]');
    if (!idInput) return;

    var currentVariant = null;
    var currentVariantId = String(idInput.value || "");
    var compatibleVariant = null;
    for (var i = 0; i < productData.variants.length; i += 1) {
      var variant = productData.variants[i];
      if (!variant || !variant.id) continue;
      if (String(variant.id) === currentVariantId) currentVariant = variant;
      if (!compatibleVariant && variantSupportsPlan(variant, selectedPlanId)) compatibleVariant = variant;
    }

    if (currentVariant && variantSupportsPlan(currentVariant, selectedPlanId)) return;

    if (compatibleVariant) {
      syncVariantIdInForm(form, compatibleVariant);
    } else {
      // Never submit an invalid plan/variant combination.
      selectedPlan.checked = false;
    }
  }

  function bindQuickViewSubscriptionUI() {
    var activeQuickViewItem = document.querySelector('[data-quick-view-item-holder].is-active [data-quick-view-item]');
    if (!activeQuickViewItem) return;

    var root = activeQuickViewItem.querySelector(".product__subs__wrap");
    if (!root || root.dataset.qafBound === "true") return;
    root.dataset.qafBound = "true";

    var cardsContainer = root.querySelector(".program-cards");
    var cards = cardsContainer ? cardsContainer.querySelectorAll(":scope > .program-card") : [];
    cards.forEach(function (card) {
      var mainRadio = card.querySelector(".program-card__radio");

      if (mainRadio) {
        mainRadio.addEventListener("change", function () {
          activateSubscriptionCard(root, card);
        });
      }

      card.addEventListener("click", function (event) {
        var tag = (event.target.tagName || "").toLowerCase();
        if (tag === "select" || tag === "input") return;
        if (tag === "button") event.preventDefault();
        activateSubscriptionCard(root, card);
      });
    });

    root.querySelectorAll(".selling_plan_program-card__radio").forEach(function (regularPlanRadio) {
      regularPlanRadio.addEventListener("change", function () {
        handleRegularPlanSelection(root, regularPlanRadio, root.closest("[data-quick-view-item]") || getActiveQuickViewItem());
      });
    });

    root.querySelectorAll("[data-selling-plan-select]").forEach(function (select) {
      select.addEventListener("change", function () {
        var planId = this.value;
        if (!planId) return;

        var card = this.closest(".program-card");
        if (card) {
          activateSubscriptionCard(root, card);
        }
        var optionLabel = this.options && this.selectedIndex > -1 ? this.options[this.selectedIndex].text : "";
        setSupplyAmountForPlanId(root, planId, optionLabel);
        setSellingPlanById(root, planId, root.closest("[data-quick-view-item]") || getActiveQuickViewItem());
      });
    });

    root.querySelectorAll('.card-info[data-subscription-type="supply-amount"] .radio__input').forEach(function (radio) {
      radio.addEventListener("change", function () {
        var oneTimeCard = root.querySelector(".program-card--one-time");
        if (oneTimeCard) activateSubscriptionCard(root, oneTimeCard);
      });
    });

    var initiallyChecked = root.querySelector(".program-card .program-card__radio:checked");
    if (initiallyChecked) {
      var initialCard = initiallyChecked.closest(".program-card");
      if (initialCard) activateSubscriptionCard(root, initialCard);
    }

    var form = activeQuickViewItem.querySelector("form.product__form, form.shopify-product-form");
    if (form && !form.dataset.qafSubmitBound) {
      form.dataset.qafSubmitBound = "true";
      var submitPreflight = function (event) {
        var activeForm = event && event.currentTarget ? event.currentTarget : form;
        var currentItem = activeForm && activeForm.closest
          ? activeForm.closest("[data-quick-view-item]")
          : null;
        if (!currentItem) currentItem = getActiveQuickViewItem();
        var currentRoot = currentItem ? currentItem.querySelector(".product__subs__wrap") : root;
        prepareSubscriptionStateForSubmit(currentRoot, currentItem || activeQuickViewItem);
      };

      // Capture phase ensures our sync runs before theme add-to-cart handlers read FormData.
      form.addEventListener("submit", submitPreflight, true);

      var addToCartButton = form.querySelector("[data-add-to-cart]");
      if (addToCartButton) {
        addToCartButton.addEventListener("click", submitPreflight, true);
      }
    }
  }

  function reinitializeSkio() {
    var skio = window.Skio || window.skio || window.SKIO;
    if (!skio) return;

    try {
      if (typeof skio.init === "function") skio.init();
      if (typeof skio.refresh === "function") skio.refresh();
      if (typeof skio.mount === "function") skio.mount();
    } catch (error) {
      // Keep silent in production; fallback handlers still work.
    }
  }

  function bindQuickViewWithRetries(attempt) {
    var tryCount = attempt || 0;
    var activeQuickViewItem = document.querySelector('[data-quick-view-item-holder].is-active [data-quick-view-item]');
    var root = activeQuickViewItem ? activeQuickViewItem.querySelector(".product__subs__wrap") : null;

    if (root) {
      bindQuickViewSubscriptionUI();
      reinitializeSkio();
      return;
    }

    if (tryCount >= MAX_BIND_RETRIES) return;

    setTimeout(function () {
      bindQuickViewWithRetries(tryCount + 1);
    }, BIND_RETRY_DELAY);
  }

  function setCtaLoadingState(button, isLoading) {
    if (!button) return;
    if (isLoading) {
      button.classList.add("is-loading");
      if (button._qafLoadingTimer) {
        clearTimeout(button._qafLoadingTimer);
      }
      // Safety fallback if quick-view fails to open.
      button._qafLoadingTimer = setTimeout(function () {
        button.classList.remove("is-loading");
        button._qafLoadingTimer = null;
      }, 5000);
      return;
    }

    button.classList.remove("is-loading");
    if (button._qafLoadingTimer) {
      clearTimeout(button._qafLoadingTimer);
      button._qafLoadingTimer = null;
    }
  }

  function clearAllQafLoadingStates() {
    document.querySelectorAll('[data-quick-add-feature] [data-button-quick-view].is-loading').forEach(function (button) {
      setCtaLoadingState(button, false);
    });
  }

  sections.forEach(function (section) {
    var viewport = section.querySelector("[data-qaf-viewport]");
    var prev = section.querySelector("[data-qaf-prev]");
    var next = section.querySelector("[data-qaf-next]");
    if (!viewport || !prev || !next) return;

    function getStep() {
      var firstCard = viewport.querySelector(".quick-add-feature__card");
      if (!firstCard) return viewport.clientWidth * 0.85;

      var cardWidth = firstCard.getBoundingClientRect().width;
      var track = section.querySelector(".quick-add-feature__track");
      var gap = 0;

      if (track) {
        var styles = window.getComputedStyle(track);
        gap = parseFloat(styles.columnGap || styles.gap) || 0;
      }

      return cardWidth + gap;
    }

    function scrollByStep(direction) {
      viewport.scrollBy({
        left: direction * getStep(),
        behavior: "smooth",
      });
    }

    prev.addEventListener("click", function () {
      scrollByStep(-1);
    });

    next.addEventListener("click", function () {
      scrollByStep(1);
    });

    section.querySelectorAll("[data-button-quick-view]").forEach(function (button) {
      button.addEventListener("click", function () {
        setCtaLoadingState(button, true);
      });
    });
  });

  document.addEventListener("theme:popup:open", function () {
    clearAllQafLoadingStates();
    bindQuickViewWithRetries(0);
  });

  document.addEventListener("change", function (event) {
    if (!event.target || !event.target.closest) return;

    var regularPlanRadio = event.target.closest('.popup-quick-view .selling_plan_program-card__radio');
    if (regularPlanRadio) {
      var regularRoot = regularPlanRadio.closest(".product__subs__wrap");
      if (regularRoot) {
        handleRegularPlanSelection(
          regularRoot,
          regularPlanRadio,
          regularRoot.closest("[data-quick-view-item]") || getActiveQuickViewItem()
        );
      }
      return;
    }

    var prepaidSelect = event.target.closest('.popup-quick-view [data-selling-plan-select]');
    if (prepaidSelect) {
      var prepaidRoot = prepaidSelect.closest(".product__subs__wrap");
      var prepaidCard = prepaidSelect.closest(".program-card");
      if (!prepaidRoot) return;

      if (prepaidCard) {
        activateSubscriptionCard(prepaidRoot, prepaidCard);
      }
      if (prepaidSelect.value) {
        setSellingPlanById(
          prepaidRoot,
          prepaidSelect.value,
          prepaidRoot.closest("[data-quick-view-item]") || getActiveQuickViewItem()
        );
      }
    }
  });

  // Delegated fallback: if dynamic content misses initial binding, still allow card selection.
  document.addEventListener("click", function (event) {
    var clickedCard = event.target && event.target.closest
      ? event.target.closest('.popup-quick-view .program-cards > .program-card')
      : null;
    if (!clickedCard) return;

    var tag = (event.target.tagName || "").toLowerCase();
    if (tag === "select" || tag === "input") return;
    if (tag === "button") event.preventDefault();

    var root = clickedCard.closest(".product__subs__wrap");
    if (!root) return;
    activateSubscriptionCard(root, clickedCard);
  });
})();
